// import styles
import "../../../style.scss";

const ModernTradeSidebar = (props) =>{
    // Destructure props to get title, headers, and data
    const { title = "Report", headers = [], data = []} = props;
    
    return (
        <>
        {/* <!--main content wrapper--> */}
        <div class="mcw">
        {/* <!--navigation here--> */}
        {/* <!--main content view--> */}
        <div class="cv">
            <div>
            <div class="inbox">
                <div class="inbox-sb">
                    {title}
                </div>
                <div class="inbox-bx container-fluid">
                <div class="row">
                    <div class="col-md-12">
                    <table class="table table-stripped table-responsive">
                        <tbody>
                        {data.length > 0 ? (
                            data.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td>
                                <input type="checkbox" />
                                </td>
                                <td>
                                <i className="fa fa-star-o"></i>
                                </td>
                                <td>{row.Firstname}</td>
                                <td>{row.Lastname}</td>
                                <td>{row.Email || ''}</td>
                                <td>{row.Email}</td>
                            </tr>
                            ))
                        ) : (
                            <tr>
                            <td colSpan={6} className="text-center">
                                No data available
                            </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>
        </>
    )
}

export default ModernTradeSidebar;